import {del, get, patch, post} from '../../utils/ApiUtil';

/**
 * Get personal access tokens for a data provider
 *
 * @param {string} dataProviderId
 * @returns {Promise<*>}
 */
export async function getPersonalAccessTokens(dataProviderId) {
  return await get(`/api/admin/data-providers/${dataProviderId}/tokens`);
}

/**
 * Generate personal access token
 *
 * @param {string} dataProviderId
 * @param {string} name
 * @returns {Promise<*>}
 */
export async function generatePersonalAccessToken(dataProviderId, name) {
  return await post(`/api/admin/data-providers/${dataProviderId}/tokens`, { name });
}

/**
 * Delete personal access token
 *
 * @param {string} dataProviderId
 * @param {string} tokenId
 * @returns {Promise<*>}
 */
export async function deletePersonalAccessToken(dataProviderId, tokenId) {
  return await del(`/api/admin/data-providers/${dataProviderId}/tokens/${tokenId}`);
}